module.exports = __webpack_public_path__ + "6.0619c1c1.jpg";